<adapt-dialog [maxWidth]="600"
              [expandable]="false"
              [showHelpButton]="false">
    <h3 adapt-dialog-title>Unsaved changes</h3>

    <div adapt-dialog-content>
        @if (dialogData.message) {
            <div [froalaView]="dialogData.message"></div>
        }
    </div>

    <div adapt-dialog-footer
         class="ms-auto">
        @if (dialogData.entitiesValid) {
            <button class="btn btn-primary"
                    (click)="save()">Save and continue</button>
        }
        <button class="btn btn-danger"
                (click)="discard()">Discard and continue</button>
        <button class="btn btn-default"
                (click)="stay()">Stay here</button>
    </div>
</adapt-dialog>
